import { render, staticRenderFns } from "./EditDialogAchatFrais.vue?vue&type=template&id=6e77f772&"
import script from "./EditDialogAchatFrais.vue?vue&type=script&lang=ts&"
export * from "./EditDialogAchatFrais.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports